/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react';
import { APIEndpoint } from "../../../utils/axios";
import { DataGrid, EditModal, UploadModal } from "../../../common";
import { getCultureFromLs, onDownloadXlsFile } from '../../../utils/commonFunctions';
import { useTranslation } from 'react-i18next';
import editIcon2 from "../../../assets/edit2.svg";
import searchIcon from '../../../assets/icons/search.svg';
import uploadItemIcon from '../../../assets/icons/upload-items.svg';
import usePermissions from '../../../utils/userPermissions';
const valueGetter = (params) => {
  const { colDef, data } = params;
  if (!data) {
    return '';
  }
  switch (colDef.field) {
    case 'hasCateringStation':
      return data.hasCateringStation ? 'Yes' : 'No';
    case 'warehouses':
      if(Array.isArray(data.warehouses) && data.warehouses.length){
        return (
          <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'355px',overflow:'auto'}}>
          <div className='sector-container justifyContentFlexStart alignItemsCenter' style={{maxWidth:'200px'}}>{data.warehouses.length > 0 ? data.warehouses.map((key, index) => (
         <span key={index} title={key.warehouseCode} className={!index?"sector-label-minGrid margSecotInit":"sector-label-minGrid"}>{key.warehouseCode} ({key.warehouseName})</span>
          )) : "None"}</div>

          </div>
          </>
      );
      }else if(Array.isArray(data.warehouses) && !data.warehouses.length){
        return (
          <div className='sector-container'>
            None
          </div>)
      }
      else{
        return (
          <div className='sector-container'>

          </div>)
      }
      // return data.hasCateringStation ? `${data.warehouseCode} (${data.warehouseName})` : ''
    case 'locationName':
      return `${data.locationName}, ${data.stateName}`;
    default:
      return '';
  }
}


const Columns = [
  { field: 'locationCode', headerName: 'Airport Code',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, suppressSizeToFit:true,flex:1, resizable:true,minWidth:150},
  { field: 'locationName', headerName: 'Location / State',suppressSizeToFit:true, resizable:true,flex:1,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, minWidth:150 },
  { field: 'airportName', headerName: 'Airport Name',suppressSizeToFit:true, resizable:true, flex:1, tooltipField: 'airportName',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },minWidth:230},
  { field: 'country', headerName: 'Country', suppressSizeToFit:true,flex:1, minWidth:100 ,maxWidth:180},
  { field: 'timezone', headerName: 'Time Zone',suppressSizeToFit:true, resizable:true, flex:1, tooltipField: 'timezone.name',valueGetter: (params) => {
    if (params.data && params.data.timezone) {
      const timezoneName = params.data.timezone?.name;
      const utcOffset = params.data.timezone?.utcOffsetText;
      return `${timezoneName} (UTC${utcOffset})`;
    }
    return null;
  },minWidth:250},
  { field: 'hasCateringStation', headerName: 'Catering Station', valueGetter: valueGetter, suppressSizeToFit:true, flex:1, minWidth:130},
  { field: 'warehouses', headerName: 'Warehouse',cellRendererFramework: valueGetter, suppressSizeToFit:true,flex:1,minWidth:250, resizable:true },
];

const EditFormField = [
  { label: 'Airport Code', attribute: 'locationCode', type: 'text', disabled: true },
  { label: 'Location Name', attribute: 'locationName', type: 'text', disabled: true },
  { label: 'Airport Name', attribute: 'airportName', type: 'text', disabled: true },
  { label: 'State', attribute: 'stateCode', type: 'select', required: true, options: [], disabled: true},
  { label: 'Address', attribute: 'address', type: 'textarea', rows: 4 },
  { label: 'Country', attribute: 'country', type: 'text', disabled: true },
  { label: 'Has Catering Station', attribute: 'hasCateringStation', type: 'checkbox',disabled: true },
];

const EditFormFieldWarehouse = [
  { label: 'Airport Code', attribute: 'locationCode', type: 'text', disabled: true },
  { label: 'Location Name', attribute: 'locationName', type: 'text', disabled: true },
  { label: 'Airport Name', attribute: 'airportName', type: 'text', disabled: true },
  { label: 'State', attribute: 'stateCode', type: 'select', required: true, options: [], disabled: true},
  { label: 'Address', attribute: 'address', type: 'textarea', rows: 4 },
  { label: 'Country', attribute: 'country', type: 'text', disabled: true },
  { label: 'Has Catering Station', attribute: 'hasCateringStation', type: 'checkbox',disabled: true },
  { label: 'Warehouses', attribute: 'warehouses', type:"rcSelectAll",options: [] }
]

const AddFormField = [
  { label: 'Airport Code', attribute: 'locationCode', type: 'text', required: true, value: null },
  { label: 'Location Name', attribute: 'locationName', type: 'text', required: true, value: null },
  { label: 'Airport Name', attribute: 'airportName', type: 'text', required: true, value: null },
  { label: 'State', attribute: 'stateCode', type: 'select', required: true, options: [] , value: null},
  { label: 'Address', attribute: 'address', type: 'textarea', rows: 4, value: null },
  { label: 'Country', attribute: 'country', type: 'text', required: true, value: null,disabled:true },
  { label: 'Has Catering Station', attribute: 'hasCateringStation', type: 'checkbox',disabled:false },
];

export const AirportsPage = (props) => {
  const { t,ready } = useTranslation();
  const [state, setState] = useState({selected:null,country:null});
  const tableRef = useRef();

  const [perPageLimit, ] = useState(50);
  const [searchKey, setSearchKey] = useState('');
  const [showUpload, setShowUpload] = useState(false);
  const [modalFormData, setModalFormData] = useState({});
  const [addFormFields,setAddFormFields]=useState(AddFormField);
  const [editFormFieldWarehouse,setEditFormFieldWarehouse]=useState(EditFormFieldWarehouse);
  const [editFieldsNoCatering,setEditFieldsNoCatering]=useState(EditFormField);
  const [updatedFormFieldValues,setUpdatedFormFieldValues]=useState({})
  const [warehouse, setWarehouse] = useState([]);
  const [airportsGlobal,setAirportGlobal]=useState([]);
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [ uploadedFile, setUploadedFile ] = useState([]);
  const [ isDisabled, setIsDisabled ] = useState(false);
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');

  const { hasPermission: editAirports } = usePermissions('edit', "orn:Account:ModifyAirportMaster");
  const { hasPermission: createAirports  } = usePermissions('create', "orn:Account:ModifyAirportMaster");
  const { hasPermission: uploadAirports  } = usePermissions('upload', "orn:Account:ModifyAirportMaster");

  React.useEffect(() => {
    fetchStates();
    fetchWarehouses();
  }, []);


React.useEffect(() => {
  const isArray = Array.isArray(updatedFormFieldValues);
  if (!isArray) {
    const isEmptyObject = !Object.keys(updatedFormFieldValues || {}).length;
    const missingStateCode = !updatedFormFieldValues?.stateCode;
    const hasCatering = updatedFormFieldValues?.hasCateringStation;
    const isModalEmpty = !Object.keys(modalFormData || {}).length;

    if (isEmptyObject || missingStateCode || (hasCatering && isModalEmpty)) {
      setIsDisabled(true);
      return;
    }

    setIsDisabled(false);
    return;
  }
  const noWarehouses = modalFormData?.warehouses?.length === 0;

  setIsDisabled(noWarehouses);
}, [updatedFormFieldValues, modalFormData]);



  React.useEffect(()=>{
    if(!Object.keys(modalFormData).length && state.selected){
      const editOptions = [{ key: 0, label: state.selected.stateName, value: state.selected.stateCode }];
      if(state.selected.hasCateringStation){
        setEditFormFieldWarehouse((prev)=>{
          const updatedFields= prev.map((editRow) => {
              if (editRow.attribute === 'stateCode') {
               editRow.options = editOptions;
             }

             if (editRow.attribute === 'warehouses') {
               editRow.options = warehouse;
               editRow.data = state.selected.warehouses.map(wr => ({key: wr.warehouseId,label: wr.warehouseName,value: wr.warehouseCode}));

               const css = document.querySelectorAll('#warehouseCode');
               css.forEach((el) => {
                 el.value = state.selected.warehouses.map(
                   (wr) => `${wr.warehouseName} (${wr.warehouseCode})`
                 ).join(', ');
               });
             }
             return editRow;
           }
          )
          return updatedFields;
         }
         )
      }else{
        setEditFieldsNoCatering((prev)=>{
          const updatedFields= prev.map((editRow) => {
              if (editRow.attribute === 'stateCode') {
               editRow.options = editOptions;
             }
             return editRow;
           }
          )
          return updatedFields;
         }
         )
      }

    }

  },[state.selected])

  React.useEffect(() => {
  const { selected } = state;

  if (!airportsGlobal.length && selected) {
    fetchAirportsGlobal();
  }

  const shouldHandleNewItem =
    !Array.isArray(updatedFormFieldValues) &&
    updatedFormFieldValues &&
    selected?.action === 'AddNewItem';

  if (!shouldHandleNewItem) return;

  const { locationCode = '', locationName, airportName, country } = updatedFormFieldValues;
  const trimmedLocationCode = locationCode.replace(/\s+/g, '');

  const updateFormFields = (iata = '', city = '', airport = '', country_code = '') => {
    setAddFormFields((prev) =>
      prev.map((editRow) => {
        switch (editRow.attribute) {
          case 'locationCode':
            editRow.value = iata || locationCode || '';
            break;
          case 'locationName':
            editRow.value = city || locationName || '';
            break;
          case 'airportName':
            editRow.value = airport || airportName || '';
            break;
          case 'country':
            editRow.value = country_code || country || '';
            break;
            default:
              break;
        }
        return editRow;
      })
    );
  };

  if (trimmedLocationCode.length >= 3) {
    const airportObj = airportsGlobal.find(
      (apt) => apt.iata === trimmedLocationCode
    );

    if (airportObj) {
      const { iata, city, airport, country_code } = airportObj;
      updateFormFields(iata, city, airport, country_code);
    } else {
      updateFormFields();
    }
  } else {
    updateFormFields();
  }
}, [updatedFormFieldValues, state.selected, airportsGlobal]);


  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };

  const fetchAirportsGlobal = async()=>{
  try {
    const res = await APIEndpoint.get('/airports_global');
    if(res && res.airports && res.airports.length>0){
      setAirportGlobal(res.airports);
    }

  } catch (error) {
    console.error("Error fetching global airports:", error);
  }
  }

  const fetchAirports = async (page=1, perPage=50) => {

    filterData.page = page;
    filterData.limit = perPage;
    filterData.searchParam = searchKey;
    const res = await APIEndpoint.post('airports/process', filterData);
    return res;
  }

  const onModalFormInputChange = (e, newFormData) => {
    const { name, value } = e.target;

    let newUpdates = modalFormData ? { ...modalFormData } : {}
    newUpdates[name] = value;

    setModalFormData((_)=>( {...newFormData,..._ }) );
  }


const onWarehouseChange=(add,updated)=>{
  setModalFormStatusObj({ text:''});
  let newUpdates = modalFormData ? { ...modalFormData } : {}
  newUpdates['warehouses']=updated??[];
  setModalFormData((_)=>({..._,...newUpdates}));
if(!add){
  setEditFormFieldWarehouse((prev)=>{
 const updatedFields= prev.map((editRow) => {
    if (editRow.attribute === 'warehouses') {
      editRow.data = [...updated];
      const elements = document.querySelectorAll('#warehouseCode');
      elements.forEach((el) => {
        el.value = [...updated];
      });
    }
    return editRow;
  })


  return updatedFields
}
  )
}else{

  setAddFormFields((prev) => {
    const updatedFields = prev.map((editRow) => {
      if (editRow.attribute === 'warehouses') {
        return {
          ...editRow,
          data: [...updated],
        };
      }
      return editRow;
    });

    return updatedFields;
  });

}


}


  const onAction = (e, action, row) => {
    setState((_prev) => {
      return { ..._prev, selected: row }
    })
  }

  const onClose = () => {
    if(state.selected.hasCateringStation){
      EditFormField.pop();
    }
    setState((_prev) => {
      return { ..._prev, selected: false }
    })
    setAddFormFields(AddFormField);
    setUpdatedFormFieldValues({});
    setModalFormStatusObj({text:''})
    setModalFormData({});
  }

  const refreshTable = () => {
    tableRef.current.refreshTableHandler();
  };

  const onEditSubmit = async (e, updated,editHsn,mode) => {
   const updatedAirportData = updated && typeof updated === 'object'
  ? Object.fromEntries(
      Object.entries(updated).filter(([_, value]) => value !== undefined)
    )
  : {};


    if(mode==='Edit Airport' && editAirports){
      if ((Object.keys(updatedAirportData).length > 0) || modalFormData) {
        const body = { ...state.selected,...(Object.keys(updatedAirportData).length > 0 ? updatedAirportData : {})};
        if( state.selected.hasCateringStation && modalFormData && modalFormData.warehouses){
          body.warehouseIds = modalFormData.warehouses.map(wh=>wh.key)
        }
        if( state.selected.hasCateringStation && modalFormData.warehouses && !modalFormData.warehouses.length ){
          setModalFormStatusObj({ error: 'Please select a warehouse'});
          return;
        }

        try {
          const res= await APIEndpoint.put(`airports`, body);
          if(res.success){
          setModalFormStatusObj({ text: res.msg ||'Data Saved Successfully'});
          handleReset();

          }
        }
        catch (error) {
         }
      }else{
        const {id} = state.selected;
        try {
         await APIEndpoint.get(`airports/get/${id}`).then((resp)=>{
        if(resp.success){
          resp.result.warehouseId = [resp.result.warehouseId]
          APIEndpoint.put(`airports`,resp.result).then((resp2)=>{
            if(resp2.success){
          setModalFormStatusObj({ text:'Data Saved'});
          handleReset();
            }
          })
        }
       })
        }
        catch (error) {
         }
      }
    }
    else if(mode==='Create Airport' && createAirports){
      if (updatedAirportData && Object.keys(updatedAirportData).length > 0) {
        const body = {country:state.country,hasCateringStation:updatedAirportData.hasCateringStation??false,locationName:addFormFields.find(sym=>sym.attribute ==='locationName')?.value,airportName:addFormFields.find(sym=>sym.attribute==='airportName')?.value,...updatedAirportData};
        if(modalFormData && modalFormData.warehouses){
          body.warehouseIds = modalFormData.warehouses.map(wh=>wh.key);
        }
        try {
          const res= await APIEndpoint.post(`airports`, body);
          if(res.success){
          setModalFormStatusObj({ text: res.msg ||'Data Saved Successfully'});
          handleReset();

          }
        }
        catch (error) {
          const errMsg=JSON.parse(error.message);
          setModalFormStatusObj({ error: errMsg.data.message || errMsg.data.msg ||'Something went wrong. Please try again after some time.'});
         }
      }
      else{
        setModalFormStatusObj({ error:"Please fill all the required fields!"});
      }


    }else{
      return null;
    }
  };

  const onUploadFileChangeHandler = async (e) => {
    const file=e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

    const formData = new FormData();
    formData.append('scheduleLater', false);
    formData.append('listName', undefined);
    formData.append('targetSectorType', undefined);
    formData.append('stores', []);
    formData.append('warehouses', []);
    formData.append('file', file);
    try {
      await APIEndpoint.post(`airports/upload`, formData);
      setUploadedFile([]);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
    } catch (error) {
      e.target.value = null;
      setUploadedFile([]);
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;

      let msgContent = "";
      if (status === 400 && data?.errors) {
            data.errors.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
            _.errors.forEach(erObj => {
              errorMsgArr.push( (erObj.field?erObj.field:"") + ' | ' + erObj.message + ' \n<br>' );
            });

            msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
        });
      } else if(status===0 && !data){
        msgContent += `Error occurred while uploading airports!<br>Please try again.`;
    }
    else if(status === 400 && data && data?.Error){
      msgHeading = data?.Error;
      msgContent += `Error occurred while uploading airports sheet!<br>Please try again.`;
    }
      else {
        msgContent += `Error occurred while uploading airports!<br>Please fix the errors and re-upload.`;
      }

      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
};

  const fetchStates = async () => {
    try {
       const resp = getCultureFromLs()
    if (resp) {
      const {countryCode,states}=resp;
      setState( (_prev) => {
        return { ..._prev, country:countryCode};
      });
      const options = [{key: 0, label: 'Select State', value: ''}];
     states.forEach((fieldValue) => {
        options.push({key: fieldValue.code, label: fieldValue.name, value: fieldValue.code});
      });
      AddFormField.map( editRow => {
        if (editRow.attribute === 'stateCode' ) {
          editRow.options = options;
        }
        if (editRow.attribute === 'country' ) {
          editRow.value = countryCode;
        }
        return editRow;
      });
    } else {
      console.log('Log: Error while fetching states');
    }
    } catch (error) {

    }

  };

  const fetchEditStates = async () => {
    if (!state.selected) return;
  };

  const fetchWarehouses = async () => {
  try {
       const resp = await APIEndpoint.get('warehouses');
    if (resp.result.length > 0) {
      const options = [];
      resp.result.filter( (fieldValue, index) => {
        options.push({key: fieldValue.id, label: fieldValue.value, value: fieldValue.warehouseCode});
        setWarehouse(options);
        return fieldValue;
      });
      EditFormField.map( editRow => {
        if (editRow.attribute === 'warehouses' ) {
          editRow.options = options;
        }
        return editRow;
      });
    } else {
      console.log('Log: Error while fetching warehouses');
    }
  } catch (error) {

  }

  };

  const onChangeAdd = (e) => {
    setModalFormStatusObj({text:''})
    const { name, checked} = e.target;
    if( name === 'hasCateringStation'){
      if(checked){
        setAddFormFields((prev) => [...prev,{
          label: 'Warehouses',
          attribute: 'warehouses',
          type: 'rcSelectAll',
          data:[],
          options: warehouse,
        },
      ]);
      }else{
        setAddFormFields((prev) => {
          const removedWh=prev.map((item)=>{
            if(item.attribute==='warehouses'){
              return null;
            }
            return item;
          }).filter(fl=>fl!==null);
          return removedWh;
        }
        );
      }


    }
  }


  const onAddItemHandler = () => {
    setState( (_prev) => {
      return { ..._prev, selected: { action: 'AddNewItem' } };
    });
  }



  const onSearch = (e) => {
      setSearchKey(e.target.value);
  };

  const onUploadClose = () => {
    setUploadedFile([]);
    setUploadFileStatusBlock('');
    setShowUpload(false);
  }

  const onDownloadSampleFile = () => {
    onDownloadXlsFile('samples/downloads/Airports_Upload_Sample','Airports_Upload_Sample')
  }
  const handleReset = () => {
    let timerId = setTimeout(() => {
      clearTimeout(timerId);
      refreshTable()
      setModalFormStatusObj({text:''})
      onClose();
    }, 500)
  }
  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>
          <div className='flexRow width100 justifyContentSpaceBetween'>

          <div className='width100Menu justifyContentCenter flexRow'>
          <div className="margLeft underline">
                  <span><img  className="icon-size" alt='search' src={searchIcon} /></span>
                  <span><input className="search" onChange={onSearch} type="search" placeholder="Search" value={searchKey}/></span>
              </div>
          </div>

         { uploadAirports?<div className="flexRow justifyContentFlexEnd margBot10">
              <span title={t('pages.pagesContent.airports.uploadButtonTitle')} className='upload dropdownStyle1-TextMedium' onClick={() => setShowUpload(true)}><img  className="icon-size-min" alt='uploadItem' src={uploadItemIcon} /></span>
          </div>:<></>}

             {createAirports? <div className="margLeft flexRow justifyContentFlexEnd alignItemsBaseline">
                  <button className="add-item-button" onClick={ onAddItemHandler }>
                  {t('pages.pagesContent.airports.addModalTitleButton')}
                  </button>
                  <button className='item-button'>
                  </button>
              </div>:<></>}
          </div>

          <DataGrid
            ref={tableRef}
            className='full-flex'
            columns={[...Columns]}
            initialPageLimit={perPageLimit}
            showDefaultFilters={false}
            searchKey={searchKey}
            actions={[{ title: '', detail: editAirports? [{src: editIcon2,value:"EditItem",title:'Edit'}]:[] }]}
            onAction={onAction}
            onAddItemHandler={() => onAddItemHandler()}
            getRows={fetchAirports} />
        </>
      }
       {state.selected ? (
        Object.keys(state.selected).length > 0 && state.selected.action !== "AddNewItem" ? (
          <>

            {fetchEditStates() && (
              <EditModal
                title={t('pages.pagesContent.airports.editModalTitle')}
                onClose={onClose}
                buttonLabel="Save"
                modalFormStatusObj={modalFormStatusObj}
                showFieldsInColumn={true}
                onSubmit={onEditSubmit}
                onChange={ (e,updated) => {
                  setUpdatedFormFieldValues(updated);
                  if(!e && updated){
                    onWarehouseChange(false,updated)
                  }
                  else {
                      onModalFormInputChange(e, updated);
                  }

              }
          }
                fields={
                  state.selected.hasCateringStation
                    ? editFormFieldWarehouse.map((_) => {
                        return { ..._, initialValue: state.selected[_.attribute] };
                      })
                    : editFieldsNoCatering.map((_) => {
                        return { ..._, initialValue: state.selected[_.attribute] };
                      })
                }
              />
            )}
          </>
        ) : (
            <EditModal
              title={t('pages.pagesContent.airports.addModalTitle')}
              modalFormStatusObj={modalFormStatusObj}
              onClose={onClose}
              buttonLabel="Save"
              disabled={isDisabled}
              showFieldsInColumn={true}
              onChange={ (e,updated) => {
                setUpdatedFormFieldValues(updated);
                if(!e && updated){
                  onWarehouseChange(true,updated)
                }
                else {
                    onChangeAdd(e);
                }
              }
               }
              onSubmit={onEditSubmit}
              fields={ addFormFields.map( (elt) => {
                  return {...elt, initialValue: {} }
                })
              }
            />
          )
        )
        : null
      }
       {
        showUpload &&
        <UploadModal
          modelTitle={t('pages.pagesContent.airports.uploadButtonTitle')}
          onUploadClose={onUploadClose}
          onDownloadSampleFile={onDownloadSampleFile}
          onUploadFileChangeHandler={onUploadFileChangeHandler}
          uploadedFile={uploadedFile}
          uploadFileStatusBlock={uploadFileStatusBlock}
        />
      }
       {
                 !ready &&<div className='overlay_hide sub'></div>
                }
    </div>
  )
}